export const history = {
  en: {
    "history.trade_history": "Trade History",
    "history.open_orders": "Open Orders",

    "history.purchase_time": "Purchase time",
    "history.closing_time": "Closing time",
    "history.asset": "Asset",
    "history.investments": "Investments",
    "history.total": "Total P/L",
    "history.equity": "Equity",
    "history.expiration_time": "Expiration time",
    "history.countdown_time": "Countdown time",
    "history.time": "Time",
  },

  ru: {
    "history.trade_history": "История торгов",
    "history.open_orders": "Открытые сделки",

    "history.purchase_time": "Дата покупки",
    "history.closing_time": "Дата закрытия",
    "history.asset": "Актив",
    "history.investments": "Инвестиции",
    "history.total": "Выплата",
    "history.equity": "Капитал",
    "history.expiration_time": "Время истечения",
    "history.countdown_time": "Время обратного отсчета",
    "history.time": "Время",
  },

  es: {
    "history.trade_history": "Historial de operaciones",
    "history.open_orders": "Órdenes abiertas",

    "history.purchase_time": "Hora de compra",
    "history.closing_time": "Hora de cierre",
    "history.asset": "Activo",
    "history.investments": "Inversiones",
    "history.total": "Total de ganancias/pérdidas",
    "history.equity": "Patrimonio",
    "history.expiration_time": "Hora de expiración",
    "history.countdown_time": "Tiempo de cuenta regresiva",
    "history.time": "Tiempo",
  },

  ua: {
    "history.trade_history": "Історія торгів",
    "history.open_orders": "Відкриті ордери",

    "history.purchase_time": "Час покупки",
    "history.closing_time": "Час закриття",
    "history.asset": "Актив",
    "history.investments": "Інвестиції",
    "history.total": "Всього P/L",
    "history.equity": "Капітал",
    "history.expiration_time": "Час закінчення",
    "history.countdown_time": "Зворотний відлік",
    "history.time": "Час",
  },
};

export default history;
